import Grid2 from '@mui/material/Unstable_Grid2';
import { Step } from '../../components/Step';
import DnsIcon from '@mui/icons-material/Dns';
import { useTranslation } from 'react-i18next';
import { CopyTextField } from 'src/shared/components/Form/CopyTextField';
import { ipList } from '../consts';

export const Step1 = () => {
  const { t } = useTranslation('settings');

  return (
    <Step
      title={`${t('integrations.step')} 1`}
      subtitle={t('integrations.castilla.you must add our ip addresses to your whitelist')}
      Icon={DnsIcon}
    >
      <Grid2 xs={12} sx={{ paddingLeft: 0, paddingRight: 0 }}>
        {ipList.map(ip => (
          <Grid2 xs={12} sx={{ marginBottom: 1 }}>
            <CopyTextField
              name={ip.label}
              label={ip.label}
              value={ip.value}
              sx={{ width: '300px' }}
              iconColor="colorPalette.0"
            />
          </Grid2>
        ))}
      </Grid2>
    </Step>
  );
};
